import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteNav } from "@/components/SiteNav";
import { Footer } from "@/components/Footer";
import { BackgroundNetwork } from "@/components/BackgroundNetwork";
import { ScrollManager } from "@/components/ScrollManager";
import Home from "@/pages/Home";
import Aziende from "@/pages/Aziende";
import AziendePiani from "@/pages/AziendePiani";
import Istituti from "@/pages/Istituti";
import Candidati from "@/pages/Candidati";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <BackgroundNetwork />
        <SiteNav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aziende" element={<Aziende />} />
          <Route path="/aziende/piani" element={<AziendePiani />} />
          <Route path="/istituti" element={<Istituti />} />
          <Route path="/candidati" element={<Candidati />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
